import React, { useState } from "react";

import { Button } from "@mui/material";

import ConfirmationDialog, { ConfirmInputProps } from "./DialogConfirmation";

type ConfirmationButtonProps = {
  onConfirm: () => void;
  dialogTitle?: string;
  dialogMessage?: string;
  confirmInput?: ConfirmInputProps;
  children: React.ReactNode;
} & React.ComponentProps<typeof Button>;

const ConfirmationButton: React.FC<ConfirmationButtonProps> = ({
  onConfirm,
  dialogTitle = "Confirm Action",
  dialogMessage = "Are you sure you want to perform this action?",
  confirmInput,
  children,
  ...rest
}) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleConfirm = () => {
    onConfirm();
    handleClose();
  };

  return (
    <>
      <Button color="error" onClick={handleClickOpen} {...rest}>
        {children}
      </Button>
      <ConfirmationDialog
        open={open}
        onClose={handleClose}
        onConfirm={handleConfirm}
        title={dialogTitle}
        message={dialogMessage}
        confirmInput={confirmInput}
      />
    </>
  );
};

export default ConfirmationButton;
